export default "__VITE_ASSET__77c2938b__"